<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>CADASTRO DE GRADE FECHADA</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field> -->
        <v-spacer></v-spacer>
        <v-btn color="blue darken-3" dark @click="save()">
          <v-icon left>mdi-send</v-icon>
          Salvar
        </v-btn>
      </v-toolbar>
      <v-form ref="form">
        <v-container fluid>
          <alert
            :visible="!!messageAlert"
            dark
            :type="typeAlert"
            :message="messageAlert"
            :clickClose="() => (messageAlert = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="1" class="pt-4">
              <label for="" class="">Grade:</label>
            </v-col>
            <v-col cols="12" xs="12" md="6">
              <v-select
                :items="grids"
                v-model="grid"
                @change="handleSelectGrid()"
                :item-text="
                  (item) =>
                    `${item.id} - ${item.sizes
                      .map((size) => size.size)
                      .join(' ')}`
                "
                item-value="id"
                label=""
                required
                dense
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col>
              <v-btn color="blue darken-3" dark @click="addNewItem()">
                <v-icon left>mdi-plus</v-icon> Adicionar Lançamento
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left input-codigo">Código</th>
                      <th
                        class="input-grid"
                        v-for="size in gridSelected.sizes"
                        :key="size.id"
                      >
                        {{ size.size }}
                      </th>
                      <th class="text-left">Total</th>
                      <th class="text-right">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idex) in closedGrids" :key="item.id">
                      <td>{{ idex + 1 }}</td>
                      <td
                        v-for="(size, idx) in item.sizes"
                        :key="`${item.id}_${size}`"
                      >
                        <v-text-field
                          hide-details
                          outlined
                          v-model="item.quantity[idx]"
                          dense
                          class="input-grid"
                        ></v-text-field>
                      </td>
                      <td>{{ getTotalLine(item) }}</td>
                      <td class="text-right">
                        <v-tooltip top color="error">
                          <!-- eslint-disable-next-line -->
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="red darken-1"
                              @click="deleteItem(item)"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import * as GridAPI from "@/api/requests/GridRequest";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    grids: [],
    grid: "",
    gridSelected: {},
    closedGrids: [],
    messageAlert: "",
    typeAlert: "suceess",
  }),

  computed: {},
  watch: {
    grid: function (value) {
      let reg = this.grids.find((item) => item.id == value);
      if (reg !== undefined) {
        this.gridSelected = reg;
      } else {
        this.gridSelected = {};
      }
    },
  },
  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getGrids();
    },
    async getGrids() {
      this.loading = true;
      this.grids = [];
      try {
        this.grids = await GridAPI.getAll();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    addNewItem() {
      let quantity = this.gridSelected.sizes.map(() => "");
      this.closedGrids.push({
        id: `new_${Math.floor(Math.random() * 9999)}`,
        sizes: this.gridSelected.sizes.map((size) => size.size),
        quantity: quantity,
      });
      // this.showFooter = true;
    },
    getTotalLine(item) {
      let total = 0;
      item.quantity.map((qtd) => {
        if (qtd !== "" && !isNaN(parseInt(qtd))) {
          total += parseInt(qtd);
        }
      });
      return parseInt(total);
    },
    async deleteItem(item) {
      try {
        const response = await fetch(`${URL}standard-grid/${item.id}`, {
          method: "DELETE",
        });
        await response.json();
        this.handleSelectGrid();
        this.typeAlert = "success";
        this.messageAlert = "Registro removido com sucesso";
      } catch (error) {
        console.log(error);
        this.typeAlert = "error";
        this.messageAlert =
          "Atenção: Não foi possível remover, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    async save() {
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}standard-grid`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            grid_id: this.grid,
            grids: this.closedGrids,
          }),
        });
        // this.closedGrids = [];
        // this.grid = "";
        this.handleSelectGrid();
        this.typeAlert = "success";
        this.messageAlert = "Registro salvo com sucesso";
        console.log(await res.json());
      } catch (error) {
        console.log(error);
        this.typeAlert = "error";
        this.messageAlert =
          "Atenção: Não foi possível salvar, tente novamente mais tarde";
      }
    },
    async handleSelectGrid() {
      this.closedGrids = [];
      try {
        let res = await fetch(`${URL}standard-grid?grid_id=${this.grid}`);
        this.closedGrids = await res.json();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.input-codigo {
  width: 100px;
}

.input-grid {
  width: 80px;
}
</style>
